import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.css'
})
export class NotFoundComponent {
  private readonly route = inject(ActivatedRoute);

  title = this.route.snapshot.data['title'] || 'Page Not Found';
  message = this.route.snapshot.data['message'] || '';
}
